'use client'

import {
  DocumentSearchResult,
  useUpdateDocumentState,
} from '@dc-shared-web/hooks/api/document'

import { Button } from '@dc-shared-web/components/shadcn/button'
import { BaseDialog } from '@dc-shared-web/components/base/BaseDialog'

export function DeleteDocumentDialog({
  document,
  onClose,
  onSuccess,
  open,
}: {
  document: DocumentSearchResult
  onClose: () => void
  onSuccess: () => void
  open: boolean
}) {
  const { mutate, isLoading: isDeletingDocument } = useUpdateDocumentState({
    documentId: document.uuid,
    onSuccess: onSuccess,
  })

  const onDeleteSubmit = () => {
    mutate({
      uuid: document._shortenedUuid,
      state: 'delete',
    })
  }

  return (
    <BaseDialog
      title='Delete document'
      isOpen={open}
      onClose={onClose}
      primaryActionSlot={
        <Button
          onClick={onDeleteSubmit}
          variant={'destructive'}
          type='submit'
          data-testid='delete-document-dialog-trigger'
          disabled={isDeletingDocument}
        >
          {isDeletingDocument ? 'Deleting...' : 'Delete'}
        </Button>
      }
    >
      <p className='tw-text-sm'>
        Are you sure you want to delete &quot;{document.fileName}&quot;?
      </p>
    </BaseDialog>
  )
}
